import { useQuery } from "@apollo/client";
import { Grid, makeStyles } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import ScheduleBoard from "./ScheduleBoard";
import SchedulePagination from "./SchedulePagination";

interface ScheduleBoardComponentProps {
  match: any;
  history: any;
}

const useStyles = makeStyles((theme) => ({
  topTitle: {
    fontFamily: "'Noto Sans KR'",
    fontSize: 48,
    fontWeight: 900,
    [theme.breakpoints.down("md")]: { fontSize: 24, paddingTop: 4 },
  },
}));

function ScheduleBoardComponent({
  match,
  history,
}: ScheduleBoardComponentProps) {
  const classes = useStyles();

  return (
    <Grid xs={12} item style={{ paddingTop: 16 }}>
      <Grid
        xs={12}
        item
        container
        style={{
          fontSize: 32,

          fontFamily: "'Noto Sans KR'",
        }}
      >
        <Grid xs={12} item className={classes.topTitle}>
          노동인권문화제 일정
        </Grid>
        <ScheduleBoard match={match} />
        {/* <Pagination count={10} /> */}
        <Grid container justify={"center"}>
          <SchedulePagination
            // setPageIndex={setPageIndex}
            // pageIndex={pageIndex}
            history={history}
            match={match}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ScheduleBoardComponent;
